import { Injectable } from '@angular/core';
import { TranslationService } from './translation.service';

@Injectable({
    providedIn: 'root'
})
export class LocaleService {

    private translations = new Map<string, string>();

    constructor(private translationService: TranslationService) {
        translationService.getTranslations().subscribe(
            (translations) => {
                var localeById = new Map<number, string>();
                translations.forEach((translation) => localeById[translation.id] = translation.locale.substring(0, 2));
                translationService.getCategoryTranslation().subscribe(
                    (categoryTranslations) => {
                        categoryTranslations.forEach((categoryTranslation) => {
                            this.translations[`${localeById[categoryTranslation.translationId]}_${categoryTranslation.categoryId}`]
                                = categoryTranslation.fullName;
                        });
                    }
                );
            }
        );
    }

    getCategoryName(locale: string, categoryId: number): string {
        return this.translations[`${locale}_${categoryId}`];
    }
}